import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { IInvoice, IProjectInvoicesResponse } from './manage-invoice.interfaces';

@Injectable()
export class ManageInvoiceService {
  private _API_BASE_URL: string = environment['API_URL'];

  public getByProject(taula: string, projectCode: string): Observable<IProjectInvoicesResponse> {
    return this.authHttp.get<any>(this._API_BASE_URL + taula + '/project/' + projectCode)
      .pipe(map(response => response || []));
  }

  public get(taula: string, ): Observable<IProjectInvoicesResponse> {
    return this.authHttp.get<any>(this._API_BASE_URL + taula)
      .pipe(map(response => response || []));
  }

  public getById(taula: string, invoiceId: string): Observable<IInvoice> {
    return this.authHttp.get<any>(this._API_BASE_URL + taula + '/' + invoiceId)
      .pipe(map(response => response || {}));
  }

  public create(taula: string, payload: IInvoice): Observable<IInvoice> {
    return this.authHttp.post<any>(this._API_BASE_URL + taula + '/', payload)
      .pipe(map(response => response || {}));
  }

  public update(taula: string, invoiceId: number, payload: IInvoice): Observable<IInvoice> {
    return this.authHttp.put<any>(this._API_BASE_URL + taula + '/' + invoiceId, payload)
      .pipe(map(response => response || []));
  }

  public destroy(taula: string, invoiceId: number): Observable<IInvoice> {
    return this.authHttp.delete<any>(this._API_BASE_URL + taula + '/' + invoiceId)
      .pipe(map(response => response || []));
  }
  constructor(private authHttp: HttpClient) { }

}
